<div class="page-faq-wrapper container pt-5">
    <div *ngFor="let item of faqs" class="row g-0">
        <div class="col-lg-12 col-md-7 col mx-auto">
        	<h2 class="faq-section-title">{{item.title}}</h2>
			<accordion [closeOthers]="false" class="faq-accordion">
				<accordion-group *ngFor="let subitem of item.items" heading="{{subitem.title}}">
					<div class="container">
                        <div class="row">
                            <div class="col-lg-12 col-sm-12 d-flex flex-column justify-content-center" [innerHTML]="subitem.content">
                                
                            </div>
                        </div>
                    </div>
				</accordion-group>
			</accordion>
        </div>
    </div>

    <div class="row g-0 pb-5"></div>
</div>

